export default __webpack_public_path__ + "static/media/CommonIps.1878041c.md";